import { getItemsPaginated } from "@/services/common";
import { getVouchers } from '@/services/vouchers';


export default {
  state: {
    vouchersInfo: {
      vouchers: [],
      busy: false,
      pageNumber: 1,
      totalVouchers: 0,
    }
  },
  mutations: {
    setVouchersPaginated(state, { results, count, pageNumber }) {
      state.vouchersInfo = { vouchers: results, totalVouchers: count, pageNumber, busy: false };
    },
    setVouchersLoadingIsBusy(state) {
      state.vouchersInfo.busy = true;
    }
  },
  actions: {
    /**
     * Load vouchers.
     */
    async loadVouchersPaginated({ commit }, payload) {
      commit('setUploadsLoadingIsBusy');
      let { results, count } = await getItemsPaginated(getVouchers, payload);
      const { pageNumber } = payload;
      commit('setVouchersPaginated', { results, count, pageNumber });
    }
  },
  getters: {
    vouchers: state => state.vouchersInfo.vouchers,
    vouchersBusy: state => state.vouchersInfo.busy,
    pageNumberVouchers: state => state.vouchersInfo.pageNumber,
    totalVouchers: state => state.vouchersInfo.totalVouchers,
  }
}



// WEBPACK FOOTER //
// ./src/store/vouchers.js